import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import HeaderBar from './../common/HeaderBar';
import {InstantSearch, SearchBox, Hits, SortBy, PoweredBy, Configure} from 'react-instantsearch/dom';
import InventoryItem from './../common/InventoryItem';
import DonateModal from '../common/DonateModal';
import GoogleMapView from '../common/GoogleMapView';
import HitMapView from '../common/HitMapView';
import HitMapMarker from '../common/HitMapMarker';
import ViewSwitch from '../common/ViewSwitch';
import { getUserLocation } from '../../actions/appActions';
import { updateSelectedMapItem } from '../../actions/inventoryActions';



const HitList = (props)=>{
    return (
        <Hits hitComponent={InventoryItem} />
    )
}

const HitMap = (props)=>{
    return (
        <HitMapView >
                            <Hits hitComponent={HitMapMarker} />
                        </HitMapView>     
    )
}

class DonateScreen extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            mode : 'list'
        }


    }
    componentWillMount(){ }
    
    componentDidMount(){
        this.props.getUserLocation();
    }

    
    render(){

        const renderViewType = ()=>{
            if(this.state.mode==='list'){
                return (
                    <HitList>
                        <ViewSwitch value={this.state.mode}  onChange={(value)=>{this.props.updateSelectedMapItem({}); this.setState({mode : value})}} options={[{ value : 'list', text : 'List View' }, { value : 'map', text : 'Map View' }]} />
                    </HitList>
                )
            } else {
                return (
                    <HitMap>
                        <ViewSwitch value={this.state.mode} onChange={(value)=>{this.props.updateSelectedMapItem({}); this.setState({mode : value})}} options={[{ value : 'list', text : 'List View' }, { value : 'map', text : 'Map View' }]} />
                    </HitMap>
                )
            }
        }
        return (
            <div className="DonateScreen">
                <DonateModal />
                <HeaderBar />
                <h1 className="f1 c-primary ta-c">DONATE</h1>
                
                <div className="DonateScreen-content">
                <InstantSearch
                        apiKey="aa4db728d33cb5c9f9032ac40c2c13d8"
                        appId="R5BM8DSN2Y"
                        indexName="items"
                    >
                        <Configure aroundLatLngViaIP={true}/>
                        <Configure getRankingInfo={true}/>


                        <SearchBox translations={{placeholder : 'Search for your item'}} />
                        <ViewSwitch value={this.state.mode}  onChange={(value)=>{this.setState({mode : value})}} options={[{ value : 'list', text : 'List View' }, { value : 'map', text : 'Map View' }]} />
                        {renderViewType()}
                        <PoweredBy />
                    </InstantSearch>
             
    

                   
                </div>


            </div>
        )
    }
}

// https://github.com/algolia/react-instantsearch/blob/master/examples/geo-search/src/App.js

DonateScreen.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        loc : state.app.userLocation
    };
}

export default  connect(mapStateProps, { getUserLocation , updateSelectedMapItem})(DonateScreen);



// WEBPACK FOOTER //
// ./src/components/screens/DonateScreen.js